module.exports = __webpack_public_path__ + "static/media/Superman.ae0b77d7.png";